
import styled from 'styled-components';
import ImageSlider from '../styles/ImageSlider';

import ACategory from './ACategory';

import {  ImgSliderItems } from './ImgSliderItems';
import Notice from './Notice';

import WhyHKC from './homecomp/WhyHKC';
import UniqueFeatures from './homecomp/UniqueFeatures';
import OurAchievements from './homecomp/OurAchievements';
import SocialMedia from './homecomp/SocialMedia';



function Home() {
  return (
    <Wrapper>
        <ImageSlider imgArr={ImgSliderItems}></ImageSlider>
          <ACategory></ACategory>
          <OurAchievements/>
          <WhyHKC/>
          <UniqueFeatures/>
          <Notice></Notice>
          <SocialMedia/>
    </Wrapper>
  )
}
const Wrapper = styled.section`

`;
export default Home